<template>
  <!-- Cancel ticket START -->
  <div class="cancel-ticket" style="display: block;"><!-- +/- display: block; -->
    <div class="calcBox-fon"></div>
    <div class="calcBox">

      <div class="clHeader">{{getname(state)}}</div>
      <div class="calcBox-container">
        <div class="clTitle">{{msg}}</div>
        <form action="">
          <button class="btn2cl clEnter" @click.once="PayCard()">OK</button>
        </form>
        <!--<div class="clTitle">Enter your ticket number</div>-->
      </div>

      </div>
    </div>
  </div>
  <!-- Cancel ticket STOP -->
</template>

<script>
  export default{
    name: 'Payment',
    props: ['state', 'msg'],
    data: ()=>{
      return {
        cardnum: '',
      }
    },
    mounted() {
      document.body.addEventListener('keypress', (e) => {
        if (e.key === 'Enter') this.PayCard()
      });
    },
    methods: {
      getname(name){
        if(name == "Error") return this.$t('errors')
      },
      PayCard(){
        this.$parent.$emit('modalClosed');
      }
    }
  };
 </script>

<style scoped>
.calcBox {
  width: 300px;
}
</style>